import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((_theme: Theme) => ({
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 40px 0 0',
  },
  editButton: {
    paddingRight: '40px',
  },
  deleteButton: {},
}));

export default useStyles;
